export const FIB_SUCCESS_REGISTRATION_URL_FLAG = 'business_registration_success';
export const CTA_DATA_FLAG = 'ctaData';
export const FIB_CTA_EVENT_NAME = `${FIB_SUCCESS_REGISTRATION_URL_FLAG}:cta`;
